import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { setSelectedPackages } from 'Store/Order/actions';
import { getPerformanceID } from 'Components/OrderItem/Redux/selectors';
import PickPackage from 'Components/PickPackage/PickPackage';

import { 
  getPackages, 
  getSelectedPackages, 
  getNumberOfOrderSeats, 
  getSelectedPackagesSum,
} from 'Store/Order/selectors';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';

interface IPropsInternal {
  performanceID: number;
  totalPrice: number;
  selectedPackages: Julius.Website.PackageRequestViewModel[];
  availablePackages: Julius.Website.PackageViewModel[];
  maxNumberOfPackages: number;
  setSelectedPackages: (selectedPackages: Julius.Website.PackageRequestViewModel[]) => void;
}

type Props = IPropsInternal;

class PickPackageContainer extends React.PureComponent<Props> {

  onPackageSelection = (selection: Julius.Website.PackageRequestViewModel) => {
    const { selectedPackages } = this.props;

    const newSelectedPackages = selectedPackages ?
      selectedPackages.filter(p =>
        !(p.packageID === selection.packageID &&
        p.discountID === selection.discountID &&
        p.priceCategoryID === selection.priceCategoryID &&
        p.sectionID === selection.sectionID)) : [];
    
    newSelectedPackages.push(selection);
    this.props.setSelectedPackages(newSelectedPackages);
  }

  render() {

    const { availablePackages } = this.props;

    if (!availablePackages || !availablePackages.length) {
      return null;
    }
    
    return (
      <WrapperBox>
        <PickPackage 
          performanceID={ this.props.performanceID }
          selectedPackages={ this.props.selectedPackages }
          availablePackages={ this.props.availablePackages }
          totalPrice={ this.props.totalPrice }
          onPackageSelection={ this.onPackageSelection }
        />
      </WrapperBox>
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    totalPrice: getSelectedPackagesSum(state),
    performanceID: getPerformanceID(state),
    availablePackages: getPackages(state),
    selectedPackages: getSelectedPackages(state),
    maxNumberOfPackages: getNumberOfOrderSeats(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    setSelectedPackages,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(PickPackageContainer);


// WEBPACK FOOTER //
// ./src/components/PickPackage/PickPackageContainer.tsx